var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"elevation":"0","color":"white","app":""}},[_c('v-img',{attrs:{"src":require("@/assets/logo.svg"),"max-height":"56px","max-width":"100px","contain":""}}),_c('v-spacer')],1),_c('v-main',[_c('v-container',{staticClass:"mt-5",attrs:{"fluid":""}},[_c('v-layout',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }